import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import * as React from 'react';
const SvgChevronDown = ({
  accessibilityText,
  forwardedRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  width: 20,
  height: 20,
  "aria-hidden": accessibilityText ? undefined : true,
  "aria-label": accessibilityText,
  fill: "currentColor",
  focusable: false,
  ref: forwardedRef,
  role: accessibilityText ? 'img' : undefined
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m15 8.32-4.43 4.45c-.16.16-.37.23-.57.23s-.41-.07-.57-.23L5 8.32 6.32 7 10 10.66 13.68 7z"
}));
export default SvgChevronDown;